var $3cc0319ead4d5f7a$exports = {};
$3cc0319ead4d5f7a$exports = {
    "Empty": `\u{7A7A}`
};


export {$3cc0319ead4d5f7a$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
